<template>
  <div>
    <base-material-card
      color="secondary"
      icon="mdi-earth"
      :title="$t('registry_locations')"
    >
      <v-layout justify-center style="flex-wrap: wrap">
        <v-radio-group
          row
          justify-center
          v-model="filter"
          @change="loadTable()"
        >
          <v-radio :label="$t('active_f_p')" value="active"></v-radio>
          <v-radio :label="$t('all_f_p')" value="all"></v-radio>
        </v-radio-group>
        <v-btn
          v-if="RBAC_EDIT_LOCATION"
          small
          @click="createLocation"
          color="primary"
          >{{ $t("create_location") }}</v-btn
        >
      </v-layout>
      <DataTables
        @editLocation="editLocation"
        @viewLocation="viewLocation"
        @copyLocation="copyLocation"
        :headers="headers"
        :tableData="tableData"
      ></DataTables>
    </base-material-card>
    <edit-location
      ref="gestLocationDialog"
      @isUpdated="loadTable"
    ></edit-location>
  </div>
</template>

<script>
import gestLocation from "@/app/eventi/gestLocation.vue";
import DataTables from "@/components/base/DataTables.vue";
import Swal from "sweetalert2";

export default {
  name: "list-location",
  components: {
    DataTables,
    "edit-location": gestLocation,
  },
  data() {
    return {
      RBAC_EDIT_LOCATION: false,
      filter: "active",
      headers: [
        { text: this.$t("image"), value: "image", type: "image" },
        { text: this.$t("name"), value: "nome" },
        { text: this.$t("nation"), value: "codiPai" },
        { text: this.$t("options"), value: "options", type: "buttons" },
      ],
      tableData: [],
    };
  },
  methods: {
    viewLocation(item) {
      this.$refs.gestLocationDialog.open("VIEW", item.id);
    },
    createLocation() {
      this.$refs.gestLocationDialog.open("ADD", null);
    },
    editLocation(item) {
      this.$refs.gestLocationDialog.open("EDIT", item.id);
    },
    copyLocation(item) {
      this.$refs.gestLocationDialog.open("ADD", item.id);
    },
    loadTable() {
      let _ = this;
      let url = "/auth/eventi/listLocation";
      _.RBAC_EDIT_LOCATION = this.checkUserRole("eventi", "WRITE_LOCATION");
      if (_.filter === "all") url += "/all";
      _.tableData = [];
      _.isFetching = true;
      this.chiamataAxios("GET", url).then((response) => {
        // Aggiunge actions e icona validazione
        _.tableData = response.data.locations.map(function (item) {
          item.options = [
            {
              icon: "mdi-magnify",
              color: "green",
              function: "viewLocation",
            },
          ];

          if (_.RBAC_EDIT_LOCATION) {
            item.options.push({
              icon: "mdi-pencil",
              color: "primary",
              function: "editLocation",
            });
            item.options.push({
              icon: "mdi-content-copy",
              color: "primary",
              function: "copyLocation",
            });
          }
          return item;
        });
        _.isFetching = false;
      });
    },
  },
  mounted() {
    this.loadTable();
  },
};
</script>